import apiClient from './base';
import { UserData } from '../hooks/useUsers';

export interface UsersListResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: UserData[];
}

export interface CreateUserPayload {
  username: string;
  password: string;
  first_name: string;
  last_name: string;
  email: string;
  role: string;
  profile_image: File | undefined;
}

export const fetchUsers = async (requestUrl: string) => {
  const response = await apiClient.get<UsersListResponse>(requestUrl);
  return response.data;
};

export const createUser = async (userData: CreateUserPayload) => {
  const formData = new FormData();

  formData.append('username', userData.username);
  formData.append('password', userData.password);
  formData.append('first_name', userData.first_name);
  formData.append('last_name', userData.last_name);
  formData.append('email', userData.email);
  formData.append('role', userData.role);

  if (userData.profile_image) {
    formData.append('profile_image', userData.profile_image);
  }

  return apiClient.post('users/', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const updateUser = async (userData: { [key: string]: any }) => {
  const payload = new FormData();

  for (const [key, value] of Object.entries(userData)) {
    payload.append(key, value);
  }

  return apiClient.patch('users/', payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const deleteUser = async (userId: number) => {
  return apiClient.delete('users/', { data: { id: userId } });
};
